export default "__VITE_ASSET__B0A4P51t__"